export default () => {
  const data = {
    event_name: 'click',
    button_name: 'map',
    page_section: 'map_section',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
